export default __webpack_public_path__ + "static/media/App_Screen_2.c529a88e.png";